module.exports = __webpack_public_path__ + "assets/img/directPurchasing_tit.0c5d3f90.png";